import { SvgIcon } from "@mui/material"
import React from "react"

interface CustomIconProps {
    fontSize?: string
    children: React.ReactNode
    sx?: object
}

export const CustomIcon = ({
    fontSize = "1.5rem",
    children,
    sx = {},
}: CustomIconProps) => {
    return (
        <SvgIcon
            sx={{
                fontSize: fontSize,
                ...sx,
            }}
        >
            {children}
        </SvgIcon>
    )
}
